<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Subjects Lost to Follow Up
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Approve for Final Status Form
      </p>
    </b-container>

    <b-container fluid class="tw-my-5">
      <b-row>
        <b-col lg="4"></b-col>
        <b-col lg="4"></b-col>
        <b-col lg="4">
          <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        </b-col>
      </b-row>
    </b-container>
    <hr>

     <b-card no-body v-if="inMyGroups(['Program PI', 'Site PI', 'Ento Data Entry Clerk'])">
        <b-tabs card fill>
          <b-tab :title="'NEW REQUESTS ('+subjects.length+')'" active v-if="inMyGroups(['Ento Data Entry Clerk', 'Data Manager', 'Epi Lead'])">
            <b-card-text >
              <SubjectFinalStatusRequestTable />
            </b-card-text>
          </b-tab>

          <b-tab :title="'READY FOR CLOSURE ('+final_status_subjects.length+')'" v-if="inMyGroups(['Ento Data Entry Clerk', 'Site PI'])">
            <b-card-text >

              <b-table striped hover :fields="final_status_fields" :items="final_status_subjects" :filter="filter">
                <template v-slot:cell(name)="data">
                  <b-link :href="data.item.case_link" target="_blank">{{ data.item.name }}</b-link>
                </template>
                <template v-slot:cell(approve)="data">
                
                    <!-- Only show approve/decline buttons for new requests -->
                    <b-button v-if="data.item.final_status == 'Final Status Form Completed'" @click="final_status_approve(data.index)" size="sm" variant="success" class="w-20">Approve</b-button>
                    <b-button v-if="data.item.final_status == 'Final Status Form Completed'" @click="final_status_decline(data.index)" size="sm" variant="danger" class="w-20 ml-2">Decline</b-button>

                    <!-- Otherwise, if it has been approved (and waiting for Final Status) -->
                    <div v-if="data.item.final_status == 'Ready To Close'">
                      Approved for closure on {{ data.item.last_status_changed }}
                    </div>

                    <!-- Otherwise, if it has been declined -->
                    <div v-if="data.item.final_status == 'Declined'">
                      Declined on {{ data.item.last_status_changed }}
                    </div>

                    <!-- And for those that are already completed... -->
                    <div v-if="data.item.final_status == 'Closed'">
                      Closed on {{ data.item.last_status_changed }}
                    </div>
                    
                </template>
              </b-table>
            </b-card-text>
          </b-tab>
        </b-tabs>
     </b-card>
     <div v-else>
       <SubjectFinalStatusRequestTable />
     </div>
     

    <b-modal id="aesae_list_modal" size="xl" :title="active_aesae_modal_title" ok-only header-class="border-bottom-0">
      <b-table striped hover :fields="aesae_list_fields" :items="active_aesae_list" :filter="filter">
        <template v-slot:cell(ae_sae_id)="data">
          <b-link :href="data.item.case_link" target="_blank">{{ data.item.ae_sae_id }}</b-link>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import SubjectFinalStatusRequestTable from "@/pages/unitaid/subject-final-status/SubjectFinalStatusRequests.vue";

import { mapActions, mapState, mapGetters } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    SubjectFinalStatusRequestTable
  },
  data: function() {
    return {
      aesae_list_fields: [
        { key: "date", label: "AE/SAE Date" },
        { key: "is_ae_sae", label: "Type" },
        { key: "status" },
        { key: "outcome" },
        { key: "ae_sae_id", label: "AE/SAE ID" },
      ],
      final_status_fields: [
        { key: "name" },
        { key: "village" },
        { key: "reason" },
        { key: "last_followup_date"},
        { key: "approve", label: "Approve to Close"},
        { key: "final_status",  sortable: true, label: "Status"}
      ],
      final_status_subjects: [],
      subjects: [],
      componentKey: 0,
      filter: null,
      active_aesae_list: [],
      active_aesae_modal_title: 'AE/SAE Cases',
    };
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    ...mapGetters('user', ['inMyGroups'])
  },
  mounted: function() {
    let that = this;
     HTTP.get("/kenya/subject_final_status/get_new").then(response => {
      that.subjects = response.data;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });

     HTTP.get("/kenya/subject_final_status/get_completed").then(response => {
      that.final_status_subjects = response.data;
    });

    that.$root.$on('viewAeSaeList', (index) => {
      that.view_aesae_list(index);
    })
  },
  methods: {
     ...mapActions('subjectfinalstatuscompleted', 
            ['getSubjectFinalCompletedCount', 'setSubjectFinalCompletedCount']),
    refreshSideNavCount(){
      this.getSubjectFinalCompletedCount().then((response) => {
                this.setSubjectFinalCompletedCount(response.data);
            });
    },
     view_aesae_list: function(index){
      let that = this;
      that.active_aesae_list = that.subjects[index].unresolved_aesae;
      that.active_aesae_modal_title = 'AE/SAE Cases for ' + that.subjects[index].name;
    },
    final_status_approve: function(index){
      let that = this;
      HTTP.post("/kenya/subject_final_status/"+that.final_status_subjects[index].id+"/", {
        status: 'rclose'
      }).then(response => {
          that.final_status_subjects.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });


    },
    final_status_decline: function(index){
      let that = this;
      HTTP.post("/kenya/subject_final_status/"+that.final_status_subjects[index].id+"/", {
        status: 'decline'
      }).then(response => {
          that.final_status_subjects.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });
    }
  }
};
</script>

<style>
</style>